"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.financialHedgeInterestRateTransformer = exports.proposalActionInterestRateTransformer = exports.fixedTermInterestRateAndFeesAprTransformer = exports.interestRateMarginForAvenTransformer = exports.interestRateIndexForCoreCardTransformer = exports.interestRateIndexForAvenTransformer = exports.accountInterestRateTransformer = exports.alOrSipInterestRateTransformer = exports.alInterestRateTransformer = exports.sipInterestRateTransformer = exports.simpleFixedInterestRateTransformer = exports.ZERO_INTEREST_RATE = exports.PartialRateIndexV2 = exports.ProposalActionInterestRate = exports.FixedTermInterestRateAndFeesApr = exports.FinancialHedgeInterestRate = exports.MortgageProductApr = exports.MortgageProductInterestRate = exports.MortgageProductPoints = exports.InterestRateMortgageAverageMarket = exports.InterestRateCostOfFunds = exports.InterestRateAprAdjuster = exports.InterestRateDiscount = exports.InterestRateIndexDeltaFromAvenToCoreCard = exports.InterestRateMarginForCoreCard = exports.InterestRateMarginForAven = exports.InterestRateIndexForCoreCard = exports.InterestRateIndexForAven = exports.CashBackRate = exports.AlInterestRate = exports.SipInterestRate = exports.SimpleFixedInterestRate = exports.AccountInterestRateDifference = exports.AccountInterestRate = exports.InterestRateUnits = exports.FixedPlanRateIndexType = exports.RateIndexType = void 0;
const assert_1 = __importDefault(require("assert"));
const util_1 = require("util");
const lodash_1 = __importStar(require("lodash"));
const assertUtils_1 = require("./assertUtils");
// TODO: Need to have one record for each type in rate_index table
// @TranslateToPython
var RateIndexType;
(function (RateIndexType) {
    RateIndexType["WSJ_PRIME"] = "WSJ_PRIME";
    RateIndexType["WSJ_PRIME_TRACKER"] = "WSJ_PRIME_TRACKER";
    RateIndexType["FFTRUL"] = "FFTRUL";
})(RateIndexType || (exports.RateIndexType = RateIndexType = {}));
// These rate indexes are only used for fixed-rate loan pricing and don't have any connection to CoreCard billing tables because they aren't used for variable rates
// @TranslateToPython
var FixedPlanRateIndexType;
(function (FixedPlanRateIndexType) {
    FixedPlanRateIndexType["TREASURY_3_YEAR"] = "TREASURY_3_YEAR";
})(FixedPlanRateIndexType || (exports.FixedPlanRateIndexType = FixedPlanRateIndexType = {}));
// @TranslateToPython
var InterestRateUnits;
(function (InterestRateUnits) {
    /** 9.99% APR is expressed as 0.0999 */
    InterestRateUnits["decimal"] = "decimal";
    /** 9.99% APR is expressed as 9.99 */
    InterestRateUnits["percent"] = "percent";
})(InterestRateUnits || (exports.InterestRateUnits = InterestRateUnits = {}));
const InterestRateClassOptionsFields = ['precisionInDecimal'];
/**
 * DO NOT EXPORT THIS CLASS
 *
 * Do not change the data in this class or any of its subclasses, otherwise it will break back-compatibility with
 * existing instances of InterestRate that exist in the database!
 */
class InterestRate {
    aprAsDecimal;
    precisionInDecimal;
    constructor(params, classOptions) {
        const paramsUnits = params.units;
        this.precisionInDecimal = classOptions.precisionInDecimal;
        switch (paramsUnits) {
            case InterestRateUnits.decimal:
                this.aprAsDecimal = params.aprAsDecimal;
                break;
            case InterestRateUnits.percent:
                this.aprAsDecimal = lodash_1.default.round(params.aprAsPercent / 100, this.precisionInDecimal);
                break;
            default:
                throw (0, assertUtils_1.assertNever)(paramsUnits, `unhandled interest rate units ${paramsUnits}`);
        }
        this.aprAsDecimal = (0, lodash_1.round)(this.aprAsDecimal, this.precisionInDecimal);
        this.validate(classOptions.validateParams);
    }
    validate(params) {
        (0, assert_1.default)(Math.abs(this.aprAsDecimal) <= 1, `APR cannot be greater than 1, found ${this.toStringAsDecimal()}`);
        if (params) {
            const { allowZeroApr, minApr, maxApr } = params;
            if (this.aprAsDecimal === 0) {
                (0, assert_1.default)(allowZeroApr, `APR is zero, but allowZeroApr=${allowZeroApr}`);
                return;
            }
            if (minApr) {
                (0, assert_1.default)(this.greaterThanOrEqual(minApr), `APR ${this.toStringAsDecimal()} must be at least minApr ${minApr.toStringAsDecimal()}`);
            }
            if (maxApr) {
                (0, assert_1.default)(this.lessThanOrEqual(maxApr), `APR ${this.toStringAsDecimal()} must be at most maxApr ${maxApr.toStringAsDecimal()}`);
            }
        }
    }
    // Comparison methods
    equals(other) {
        return this.aprAsDecimal === other.getAsDecimal();
    }
    lessThan(other) {
        return this.aprAsDecimal < other.getAsDecimal();
    }
    lessThanOrEqual(other) {
        return this.aprAsDecimal <= other.getAsDecimal();
    }
    greaterThan(other) {
        return this.aprAsDecimal > other.getAsDecimal();
    }
    greaterThanOrEqual(other) {
        return this.aprAsDecimal >= other.getAsDecimal();
    }
    /**
     * @deprecated USE WITH CAUTION
     *
     * This will not be a public method in the long term.  It is only for use during the migration where we need to connect InterestRate
     * with parts of the system that are still using numbers and naming conventions.
     */
    getAsDecimal = () => {
        return this.aprAsDecimal;
    };
    /**
     * @deprecated USE WITH CAUTION
     *
     * This will not be a public method in the long term.  It is only for use during the migration where we need to connect InterestRate
     * with parts of the system that are still using numbers and naming conventions.
     */
    getAsPercent = () => {
        return (0, lodash_1.round)(this.aprAsDecimal * 100, this.precisionInDecimal - 2);
    };
    /**
     * @deprecated USE WITH CAUTION
     *
     * This will not be a public method in the long term.  It is only for use during the migration where we need to connect InterestRate
     * with parts of the system that are still using numbers and naming conventions.
     */
    getAsBasisPoints = () => {
        return (0, lodash_1.round)(this.aprAsDecimal * 10_000, this.precisionInDecimal - 4);
    };
    toStringAsDecimal = () => {
        return this.aprAsDecimal.toFixed(this.precisionInDecimal);
    };
    toStringAsPercent = () => {
        return `${this.getAsPercent().toFixed(this.precisionInDecimal - 2)}%`;
    };
    add(addend) {
        return new InterestRate({ units: InterestRateUnits.decimal, aprAsDecimal: this.aprAsDecimal + addend.aprAsDecimal }, { precisionInDecimal: this.precisionInDecimal });
    }
    subtract = (subtrahend) => {
        return new InterestRate({ units: InterestRateUnits.decimal, aprAsDecimal: this.aprAsDecimal - subtrahend.aprAsDecimal }, { precisionInDecimal: this.precisionInDecimal });
    };
    subtractFrom = (minuend) => {
        return new InterestRate({ units: InterestRateUnits.decimal, aprAsDecimal: minuend.aprAsDecimal - this.aprAsDecimal }, { precisionInDecimal: this.precisionInDecimal });
    };
    static getFromSubtraction = ({ minuend, subtrahend, }) => {
        return new InterestRate({ units: InterestRateUnits.decimal, aprAsDecimal: minuend.aprAsDecimal - subtrahend.aprAsDecimal }, { precisionInDecimal: minuend.precisionInDecimal });
    };
    static min = (a, b) => {
        if (a.lessThanOrEqual(b)) {
            return a;
        }
        return b;
    };
    static max = (a, b) => {
        if (a.greaterThanOrEqual(b)) {
            return a;
        }
        return b;
    };
    static sortComparator = (a, b) => {
        if (a.equals(b)) {
            return 0;
        }
        if (a.lessThan(b)) {
            return -1;
        }
        return 1;
    };
}
class PositiveInterestRate extends InterestRate {
    /** @override */
    validate(params) {
        super.validate(params);
        (0, assert_1.default)(this.aprAsDecimal >= 0, `APR cannot be negative, found ${this.toStringAsDecimal()}`);
    }
}
// it's irrelevant what precision the zero interest rate has
class ZeroInterestRate extends PositiveInterestRate {
    /** @override */
    validate(params) {
        super.validate(params);
        (0, assert_1.default)(this.aprAsDecimal === 0, `APR must be 0, found ${this.toStringAsDecimal()}`);
    }
}
/**
 * A special class for asserting than an Interest Rate is valid for an account to have (rather than index, margin, etc).
 * It represents the value of a variable account interest rate at a given point in time (e.g. now, at the time of PQ, at the time of Final Offer, etc.)
 */
class AccountInterestRate extends PositiveInterestRate {
    // this field verifies that you must explicitly construct AccountInterestRate to gain its properties
    isAccountInterestRate;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 4, validateParams });
        this.isAccountInterestRate = true;
    }
    subtractDiscount = (discount) => {
        const untypedAccountInterestRate = this.subtract(discount);
        return new AccountInterestRate({ units: InterestRateUnits.decimal, aprAsDecimal: untypedAccountInterestRate.getAsDecimal() });
    };
    toSipInterestRate = () => {
        return new exports.SipInterestRate({ units: InterestRateUnits.decimal, aprAsDecimal: this.aprAsDecimal });
    };
    static getOriginalBeforeDiscount = ({ aprCountingDiscount, discount }) => {
        const untypedAccountInterestRate = aprCountingDiscount.add(discount);
        return new AccountInterestRate({ units: InterestRateUnits.decimal, aprAsDecimal: untypedAccountInterestRate.getAsDecimal() });
    };
}
exports.AccountInterestRate = AccountInterestRate;
/** Represents the difference between two AccountInterestRates (e.g. boosted APY - base APY) */
class AccountInterestRateDifference extends InterestRate {
    isAccountInterestRateDifference;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 4, validateParams });
        this.isAccountInterestRateDifference = true;
    }
    static fromAccountInterestRates = ({ minuend, subtrahend }) => {
        const result = this.getFromSubtraction({ minuend, subtrahend });
        return new AccountInterestRateDifference({ units: InterestRateUnits.decimal, aprAsDecimal: result.getAsDecimal() });
    };
}
exports.AccountInterestRateDifference = AccountInterestRateDifference;
/** Interest rate type for simple fixed-rate loans (SIL, IO) with 4 decimal places of precision */
class SimpleFixedInterestRate extends PositiveInterestRate {
    /** Maintained for backcompat */
    isSipInterestRate;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 4, validateParams });
        this.isSipInterestRate = true;
    }
}
exports.SimpleFixedInterestRate = SimpleFixedInterestRate;
/** @deprecated Use SimpleFixedInterestRate instead */
exports.SipInterestRate = SimpleFixedInterestRate;
/** A special class for asserting than an Interest Rate is valid for an AL plan to have (rather than index, margin, etc) */
class AlInterestRate extends PositiveInterestRate {
    // this field verifies that you must explicitly construct AlInterestRate to gain its properties
    isAlInterestRate;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 4, validateParams });
        this.isAlInterestRate = true;
    }
}
exports.AlInterestRate = AlInterestRate;
/** A special class for representing a cash back ratio (e.g. 0.01 for 1% cash back). */
class CashBackRate extends PositiveInterestRate {
    // this field verifies that you must explicitly construct CashBackRate to gain its properties
    isCashBackRate;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 4, validateParams });
        this.isCashBackRate = true;
    }
}
exports.CashBackRate = CashBackRate;
/** A special class for asserting than an Interest Rate is NOT valid for an account to have (instead it represents the value of an index) */
class InterestRateIndexForAven extends PositiveInterestRate {
    // this field verifies that you must explicitly construct InterestRateIndexForAven to gain its properties
    isInterestRateIndexForAven;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 4, validateParams });
        this.isInterestRateIndexForAven = true;
    }
    /** overrides add with special units */
    add = (addend) => {
        const untypedAccountInterestRate = super.add(addend);
        return new AccountInterestRate({ units: InterestRateUnits.decimal, aprAsDecimal: untypedAccountInterestRate.getAsDecimal() });
    };
    static getFromAprMinusMargin = ({ apr, margin }) => {
        const untypedInterestRateIndexForAven = this.getFromSubtraction({ minuend: apr, subtrahend: margin });
        return new InterestRateIndexForAven({ units: InterestRateUnits.decimal, aprAsDecimal: untypedInterestRateIndexForAven.getAsDecimal() });
    };
}
exports.InterestRateIndexForAven = InterestRateIndexForAven;
/** A special class for asserting than an Interest Rate is NOT valid for an account to have (instead it represents the value of an index) */
class InterestRateIndexForCoreCard extends PositiveInterestRate {
    // this field verifies that you must explicitly construct InterestRateIndexForCoreCard to gain its properties
    isInterestRateIndexForCoreCard;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 4, validateParams });
        this.isInterestRateIndexForCoreCard = true;
    }
    /** overrides add with special units */
    add = (addend) => {
        const untypedAccountInterestRate = super.add(addend);
        return new AccountInterestRate({ units: InterestRateUnits.decimal, aprAsDecimal: untypedAccountInterestRate.getAsDecimal() });
    };
}
exports.InterestRateIndexForCoreCard = InterestRateIndexForCoreCard;
/** A special class for asserting that an Interest rate is NOT valid for an account to have (instead it represents the value of a margin) */
class InterestRateMarginForAven extends InterestRate {
    // this field verifies that you must explicitly construct InterestRateMarginForAven to gain its properties
    isInterestRateMarginForAven;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 4, validateParams });
        this.isInterestRateMarginForAven = true;
    }
    subtractDiscount = (discount) => {
        const untypedDiscountedInterestRateMarginForAven = this.subtract(discount);
        return new InterestRateMarginForAven({ units: InterestRateUnits.decimal, aprAsDecimal: untypedDiscountedInterestRateMarginForAven.getAsDecimal() });
    };
    static getFromAprMinusIndex = ({ apr, index }) => {
        const untypedInterestRateMarginForAven = this.getFromSubtraction({ minuend: apr, subtrahend: index });
        return new InterestRateMarginForAven({ units: InterestRateUnits.decimal, aprAsDecimal: untypedInterestRateMarginForAven.getAsDecimal() });
    };
    static getOriginalBeforeDiscount = ({ marginCountingDiscount, discount, }) => {
        const untypedInterestRateMarginForAven = marginCountingDiscount.add(discount);
        return new InterestRateMarginForAven({ units: InterestRateUnits.decimal, aprAsDecimal: untypedInterestRateMarginForAven.getAsDecimal() });
    };
}
exports.InterestRateMarginForAven = InterestRateMarginForAven;
/** A special class for asserting that an Interest rate is NOT valid for an account to have (instead it represents the value of a margin) */
class InterestRateMarginForCoreCard extends InterestRate {
    // this field verifies that you must explicitly construct InterestRateMarginForCoreCard to gain its properties
    isInterestRateMarginForCoreCard;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 4, validateParams });
        this.isInterestRateMarginForCoreCard = true;
    }
    static getFromAprMinusIndex = ({ apr, index }) => {
        const untypedAccountInterestRate = this.getFromSubtraction({ minuend: apr, subtrahend: index });
        return new InterestRateMarginForCoreCard({ units: InterestRateUnits.decimal, aprAsDecimal: untypedAccountInterestRate.getAsDecimal() });
    };
}
exports.InterestRateMarginForCoreCard = InterestRateMarginForCoreCard;
/** A special class for converting between Aven and CoreCard interest rate margins */
class InterestRateIndexDeltaFromAvenToCoreCard extends InterestRate {
    // this field verifies that you must explicitly construct InterestRateIndexDeltaFromAvenToCoreCard to gain its properties
    isInterestRateIndexDeltaFromAvenToCoreCard;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 4, validateParams });
        this.isInterestRateIndexDeltaFromAvenToCoreCard = true;
    }
    /** converts InterestRateMarginForAven to InterestRateMarginForCoreCard by adding the delta */
    convertMarginAvenToCoreCard = (avenMargin) => {
        const untypedInterestRateMarginForCoreCard = this.add(avenMargin);
        return new InterestRateMarginForCoreCard({ units: InterestRateUnits.decimal, aprAsDecimal: untypedInterestRateMarginForCoreCard.getAsDecimal() });
    };
    /** converts InterestRateMarginForCoreCard to InterestRateMarginForAven by subtracting the delta */
    convertMarginCoreCardToAven = (coreCardMargin) => {
        const untypedInterestRateMarginForAven = this.subtractFrom(coreCardMargin);
        return new InterestRateMarginForAven({ units: InterestRateUnits.decimal, aprAsDecimal: untypedInterestRateMarginForAven.getAsDecimal() });
    };
    static getIndexDeltaBasedOnAvenAndCoreCardMargins = ({ coreCardMargin, avenMargin, }) => {
        const untypedInterestRateIndexDeltaFromAvenToCoreCard = InterestRate.getFromSubtraction({ minuend: coreCardMargin, subtrahend: avenMargin });
        return new InterestRateIndexDeltaFromAvenToCoreCard({ units: InterestRateUnits.decimal, aprAsDecimal: untypedInterestRateIndexDeltaFromAvenToCoreCard.getAsDecimal() });
    };
    static getIndexDeltaBasedOnAvenAndCoreCardIndices = ({ coreCardIndex, avenIndex, }) => {
        const untypedInterestRateIndexDeltaFromAvenToCoreCard = InterestRate.getFromSubtraction({ minuend: avenIndex, subtrahend: coreCardIndex });
        return new InterestRateIndexDeltaFromAvenToCoreCard({ units: InterestRateUnits.decimal, aprAsDecimal: untypedInterestRateIndexDeltaFromAvenToCoreCard.getAsDecimal() });
    };
}
exports.InterestRateIndexDeltaFromAvenToCoreCard = InterestRateIndexDeltaFromAvenToCoreCard;
class InterestRateDiscount extends InterestRate {
    // this field verifies that you must explicitly construct InterestRateDiscount to gain its properties
    isInterestRateDiscount;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 4, validateParams });
        this.isInterestRateDiscount = true;
    }
    static getFromMarginMinusPromo = ({ baselineMargin, promoMargin }) => {
        const untypedInterestRateDiscount = this.getFromSubtraction({ minuend: baselineMargin, subtrahend: promoMargin });
        return new InterestRateDiscount({ units: InterestRateUnits.decimal, aprAsDecimal: untypedInterestRateDiscount.getAsDecimal() });
    };
    static getFromAprMinusPromo = ({ baselineApr, promoApr }) => {
        const untypedInterestRateDiscount = this.getFromSubtraction({ minuend: baselineApr, subtrahend: promoApr });
        return new InterestRateDiscount({ units: InterestRateUnits.decimal, aprAsDecimal: untypedInterestRateDiscount.getAsDecimal() });
    };
    // can add more supported types besides AlInterestRate
    static getFromAprMinusAdjusted = ({ apr, adjustedApr, }) => {
        const untypedInterestRateDiscount = this.getFromSubtraction({ minuend: apr, subtrahend: adjustedApr });
        return new InterestRateDiscount({ units: InterestRateUnits.decimal, aprAsDecimal: untypedInterestRateDiscount.getAsDecimal() });
    };
}
exports.InterestRateDiscount = InterestRateDiscount;
/**
 * A special class for representing APR adjustments that are added to or subtracted from an APR.
 * Unlike InterestRateDiscount (which is semantically for subtraction), this represents a general adjustment
 * that can be positive (increase) or negative (decrease).
 */
class InterestRateAprAdjuster extends InterestRate {
    // this field verifies that you must explicitly construct InterestRateAprAdjuster to gain its properties
    isInterestRateAprAdjuster;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 4, validateParams });
        this.isInterestRateAprAdjuster = true;
    }
}
exports.InterestRateAprAdjuster = InterestRateAprAdjuster;
class InterestRateCostOfFunds extends PositiveInterestRate {
    // this field verifies that you must explicitly construct InterestRateCostOfFunds to gain its properties
    isInterestRateCostOfFunds;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 4, validateParams });
        this.isInterestRateCostOfFunds = true;
    }
}
exports.InterestRateCostOfFunds = InterestRateCostOfFunds;
class InterestRateMortgageAverageMarket extends InterestRate {
    // this field verifies that you must explicitly construct InterestRateMortgageAverageMarket to gain its properties
    isInterestRateMortgageAverageMarket;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 4, validateParams });
        this.isInterestRateMortgageAverageMarket = true;
    }
}
exports.InterestRateMortgageAverageMarket = InterestRateMortgageAverageMarket;
class MortgageProductPoints extends InterestRate {
    // this field verifies that you must explicitly construct MortgageProductPoints to gain its properties
    isMortgageProductPoints;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 5, validateParams });
        this.isMortgageProductPoints = true;
    }
}
exports.MortgageProductPoints = MortgageProductPoints;
// This is NOT the APR, it is the interest rate. However, we use the interest rate class construct for safety.
class MortgageProductInterestRate extends PositiveInterestRate {
    // this field verifies that you must explicitly construct MortgageProductInterestRate to gain its properties
    isMortgageProductInterestRate;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 5, validateParams });
        this.isMortgageProductInterestRate = true;
    }
}
exports.MortgageProductInterestRate = MortgageProductInterestRate;
class MortgageProductApr extends PositiveInterestRate {
    // this field verifies that you must explicitly construct MortgageProductApr to gain its properties
    isMortgageProductApr;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 5, validateParams });
        this.isMortgageProductApr = true;
    }
}
exports.MortgageProductApr = MortgageProductApr;
class FinancialHedgeInterestRate extends PositiveInterestRate {
    // this field verifies that you must explicitly construct FinancialHedgeInterestRate to gain its properties
    isFinancialHedgeInterestRate;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 6, validateParams });
        this.isFinancialHedgeInterestRate = true;
    }
}
exports.FinancialHedgeInterestRate = FinancialHedgeInterestRate;
/**
 * A special class for representing fixed-term interest rate and fees APR.
 * This represents the combined APR including both interest rate and fees for fixed-term offers.
 */
class FixedTermInterestRateAndFeesApr extends PositiveInterestRate {
    // this field verifies that you must explicitly construct FixedTermInterestRateAndFeesApr to gain its properties
    isFixedTermInterestRateAndFeesApr;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 4, validateParams });
        this.isFixedTermInterestRateAndFeesApr = true;
    }
}
exports.FixedTermInterestRateAndFeesApr = FixedTermInterestRateAndFeesApr;
/**
 * A special class for representing interest rates in proposal actions.
 * This class is designed to be serializable for JSONB storage in proposal_action_details.
 *
 * Unlike other interest rate classes that use InterestRateTransformer for DB column serialization,
 * this class is designed for JSONB storage where the entire object is serialized.
 *
 * @example
 * // Create from decimal
 * const rate = new ProposalActionInterestRate({ aprAsDecimal: 0.235, units: InterestRateUnits.decimal })
 *
 * // Create from percent
 * const rate = new ProposalActionInterestRate({ aprAsPercent: 23.5, units: InterestRateUnits.percent })
 *
 * // Get values
 * rate.getAsDecimal() // 0.235
 * rate.getAsPercent() // 23.5
 *
 * // Serialize for JSONB storage
 * rate.toSerializable() // { aprAsDecimal: 0.235, isProposalActionInterestRate: true }
 *
 * // Deserialize from JSONB
 * ProposalActionInterestRate.fromSerializable(serialized)
 */
class ProposalActionInterestRate extends PositiveInterestRate {
    // this field verifies that you must explicitly construct ProposalActionInterestRate to gain its properties
    isProposalActionInterestRate;
    constructor(params, validateParams) {
        super(params, { precisionInDecimal: 4, validateParams });
        this.isProposalActionInterestRate = true;
    }
    /**
     * Converts this interest rate to a plain object that can be serialized to JSONB.
     */
    toSerializable() {
        return {
            aprAsDecimal: this.aprAsDecimal,
            isProposalActionInterestRate: true,
        };
    }
    /**
     * Creates a ProposalActionInterestRate from a serialized representation.
     * Use this when reading from JSONB storage.
     */
    static fromSerializable(serialized) {
        return new ProposalActionInterestRate({ aprAsDecimal: serialized.aprAsDecimal, units: InterestRateUnits.decimal });
    }
}
exports.ProposalActionInterestRate = ProposalActionInterestRate;
class PartialRateIndexV2 {
    rateValue;
    rateIndexType;
    constructor(partialRateIndex) {
        this.rateIndexType = partialRateIndex.rateIndexType;
        this.rateValue = new PositiveInterestRate({ aprAsDecimal: partialRateIndex.rateValue, units: InterestRateUnits.decimal }, { precisionInDecimal: 4 });
    }
    getV1 = () => {
        return { rateValue: this.rateValue.getAsDecimal(), rateIndexType: this.rateIndexType };
    };
    getDebugString = () => {
        return (0, util_1.inspect)({ rateIndexType: this.rateIndexType, rateValue: this.rateValue.toStringAsDecimal() });
    };
}
exports.PartialRateIndexV2 = PartialRateIndexV2;
exports.ZERO_INTEREST_RATE = new ZeroInterestRate({ units: InterestRateUnits.decimal, aprAsDecimal: 0 }, { precisionInDecimal: 4 });
class InterestRateTransformer {
    to(value) {
        if (lodash_1.default.isNil(value)) {
            return null;
        }
        return JSON.stringify(lodash_1.default.omit(value, InterestRateClassOptionsFields));
    }
    from(value) {
        if (lodash_1.default.isNil(value)) {
            return null;
        }
        return this.fromJsonObject(JSON.parse(String(value)));
    }
}
class SipInterestRateTransformer extends InterestRateTransformer {
    fromJsonObject = (jsonObject) => new exports.SipInterestRate({ units: InterestRateUnits.decimal, aprAsDecimal: jsonObject.aprAsDecimal });
}
class InterestRateIndexForAvenTransformer extends InterestRateTransformer {
    fromJsonObject = (jsonObject) => new InterestRateIndexForAven({ units: InterestRateUnits.decimal, aprAsDecimal: jsonObject.aprAsDecimal });
}
class InterestRateIndexForCoreCardTransformer extends InterestRateTransformer {
    fromJsonObject = (jsonObject) => new InterestRateIndexForCoreCard({ units: InterestRateUnits.decimal, aprAsDecimal: jsonObject.aprAsDecimal });
}
class AlInterestRateTransformer extends InterestRateTransformer {
    fromJsonObject = (jsonObject) => new AlInterestRate({ units: InterestRateUnits.decimal, aprAsDecimal: jsonObject.aprAsDecimal });
}
class AlOrSipInterestRateTransformer extends InterestRateTransformer {
    fromJsonObject = (jsonObject) => {
        const isSip = !!jsonObject.isSipInterestRate;
        const isAl = !!jsonObject.isAlInterestRate;
        (0, assert_1.default)(isSip === !isAl, `expected json object to be a SIP xor an AL interest rate, but found ${(0, util_1.inspect)({ isSip, isAl })} for ${(0, util_1.inspect)(jsonObject)}`);
        if (isSip) {
            return new exports.SipInterestRate({ units: InterestRateUnits.decimal, aprAsDecimal: jsonObject.aprAsDecimal });
        }
        return new AlInterestRate({ units: InterestRateUnits.decimal, aprAsDecimal: jsonObject.aprAsDecimal });
    };
}
class AccountInterestRateTransformer extends InterestRateTransformer {
    fromJsonObject = (jsonObject) => new AccountInterestRate({ units: InterestRateUnits.decimal, aprAsDecimal: jsonObject.aprAsDecimal });
}
class InterestRateMarginForAvenTransformer extends InterestRateTransformer {
    fromJsonObject = (jsonObject) => new InterestRateMarginForAven({ units: InterestRateUnits.decimal, aprAsDecimal: jsonObject.aprAsDecimal });
}
class FixedTermInterestRateAndFeesAprTransformer extends InterestRateTransformer {
    fromJsonObject = (jsonObject) => new FixedTermInterestRateAndFeesApr({ units: InterestRateUnits.decimal, aprAsDecimal: jsonObject.aprAsDecimal });
}
class ProposalActionInterestRateTransformer extends InterestRateTransformer {
    fromJsonObject = (jsonObject) => new ProposalActionInterestRate({ units: InterestRateUnits.decimal, aprAsDecimal: jsonObject.aprAsDecimal });
}
class FinancialHedgeInterestRateTransformer extends InterestRateTransformer {
    fromJsonObject = (jsonObject) => new FinancialHedgeInterestRate({ units: InterestRateUnits.decimal, aprAsDecimal: jsonObject.aprAsDecimal });
}
exports.simpleFixedInterestRateTransformer = new SipInterestRateTransformer();
/** @deprecated Use simpleFixedInterestRateTransformer instead */
exports.sipInterestRateTransformer = exports.simpleFixedInterestRateTransformer;
exports.alInterestRateTransformer = new AlInterestRateTransformer();
exports.alOrSipInterestRateTransformer = new AlOrSipInterestRateTransformer();
exports.accountInterestRateTransformer = new AccountInterestRateTransformer();
exports.interestRateIndexForAvenTransformer = new InterestRateIndexForAvenTransformer();
exports.interestRateIndexForCoreCardTransformer = new InterestRateIndexForCoreCardTransformer();
exports.interestRateMarginForAvenTransformer = new InterestRateMarginForAvenTransformer();
exports.fixedTermInterestRateAndFeesAprTransformer = new FixedTermInterestRateAndFeesAprTransformer();
exports.proposalActionInterestRateTransformer = new ProposalActionInterestRateTransformer();
exports.financialHedgeInterestRateTransformer = new FinancialHedgeInterestRateTransformer();
